var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.95 5.285H0.975C0.45 5.285 0 5.66 0 6.185V16.16C0 16.685 0.45 17.06 0.975 17.06H14.025V5.285H13.95Z",
    fill: "#00C1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.05005 20.135C5.32505 20.135 6.30005 19.085 6.30005 17.885C6.30005 16.685 5.25005 15.635 4.05005 15.635C2.85005 15.635 1.80005 16.685 1.80005 17.885C1.80005 19.085 2.85005 20.135 4.05005 20.135Z",
    fill: "#00C1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.825 20.135C17.1 20.135 18.075 19.085 18.075 17.885C18.075 16.685 17.025 15.635 15.825 15.635C14.625 15.635 13.575 16.685 13.575 17.885C13.575 19.085 14.625 20.135 15.825 20.135Z",
    fill: "#00C1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 3.86H1.80005V15.635H15.375V3.86Z",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 8.36H18.975L21.675 11.06V15.56H15.3",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8501 20.135C7.1251 20.135 8.1001 19.085 8.1001 17.885C8.1001 16.685 7.0501 15.635 5.8501 15.635C4.6501 15.635 3.6001 16.685 3.6001 17.885C3.6001 19.085 4.6501 20.135 5.8501 20.135Z",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 20.135C18.9 20.135 19.875 19.085 19.875 17.885C19.875 16.685 18.825 15.635 17.625 15.635C16.425 15.635 15.375 16.685 15.375 17.885C15.375 19.085 16.425 20.135 17.625 20.135Z",
    stroke: "#131416",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4187 6.41602L21.9195 7.35455",
    stroke: "#FFC100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8733 4.22142L20.3756 5.90338",
    stroke: "#FFC100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6321 4.29387L18.3428 5.7053",
    stroke: "#FFC100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.9cacea05.svg";
export { ForwardRef as ReactComponent };